export default "__VITE_ASSET__D1UB2Jv7__"